import { render, staticRenderFns } from "./WalletInfo.vue?vue&type=template&id=6133da82&scoped=true&"
import script from "./WalletInfo.vue?vue&type=script&lang=ts&"
export * from "./WalletInfo.vue?vue&type=script&lang=ts&"
import style0 from "./WalletInfo.vue?vue&type=style&index=0&id=6133da82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133da82",
  null
  
)

export default component.exports